import React from 'react';
import { withRouter } from 'react-router';
import { Container, Row } from 'reactstrap';

import { Summary } from '../../Common';
import { Stripe, InjectInvoiceData } from '../../../../components';

type Props = {
  trackTrekPayment: () => void,
  history: Object,
  location: {
    pathname: string,
  },
};

// Note: Both SelfGuided and Guided Payment Document Titles are changed in Summary Component
// @see screens/treks/common/Summary

const Payment = (props: Props) => (
  <InjectInvoiceData>
    {({ invoice, invoiceId }) => {
      const { amount: totalAmount, status } = invoice;

      const isInvoicePending = status.toLowerCase() === 'pending';

      return (
        <Container>
          <Row>
            {isInvoicePending && (
              <Stripe
                invoiceId={invoiceId}
                amount={totalAmount}
                onSuccess={() => {
                  props.history.push(`${props.location.pathname}/payment-success`);
                }}
              />
            )}
            <Summary invoice={invoice} />{' '}
          </Row>
        </Container>
      );
    }}
  </InjectInvoiceData>
);

export default withRouter(Payment);



// WEBPACK FOOTER //
// ./src/screens/Trek/Guided/Payment/Payment.js